module.exports = __webpack_public_path__ + "media/application/images/ui/consumer-trusted-badge-3bf0818ecf994fb22527ab7c7d5f4022.png";